module.exports = __webpack_public_path__ + "static/media/OrientationPDF.5a49539f.pdf";